import { isAddress, isHex, toHex } from 'viem';
/** Install a subscription */
export async function installSubscription(args) {
    const { paymasterProxyUrl, paymasterProxyAuthSecret, spaceAddress, tokenId, smartAccount, signer, } = args;
    const encodedInstallationData = await getInstallationData({
        paymasterProxyUrl,
        paymasterProxyAuthSecret,
        spaceAddress,
        tokenId,
        smartAccountAddress: smartAccount.address,
    });
    // there are 2 ways to make a installValidation userop work:
    // pass encodedInstallationData as the encoded call data for the userop. That means the account is going to call installValidation directly (not execute or executeBatch)
    // OR you can pass encodedInstallationData as the data used in executeBatch
    // which is what i'm doing here because it follows our existing api where everything is encoded into execute/executeBatch
    //
    // IMPORTANT: if you use execute instead of executeBatch, it will not work! i think because there is some code in the modular contract around doing validating a call to self with execute
    // so this has to use executeBatch
    // see getCallDataForUserop.ts, it has special handling for installSubscription so that data is encoded correctly
    return smartAccount.sendUserOp({
        // arrays mean executeBatch
        toAddress: [smartAccount.address],
        callData: [encodedInstallationData],
        functionHashForPaymasterProxy: 'installSubscription',
        spaceId: undefined,
        signer,
        skipConfirmation: true,
    });
}
export async function getInstallationData(args) {
    const { paymasterProxyUrl, paymasterProxyAuthSecret, spaceAddress, tokenId, smartAccountAddress, } = args;
    if (!isAddress(spaceAddress)) {
        throw new Error('Invalid space address');
    }
    if (!isAddress(smartAccountAddress)) {
        throw new Error('Invalid smart account address');
    }
    let tokenIdHex;
    if (!isHex(tokenId)) {
        tokenIdHex = toHex(Number(tokenId));
    }
    else {
        tokenIdHex = tokenId;
    }
    const response = await fetch(`${paymasterProxyUrl}/api/subscriptions/encode-installation`, {
        method: 'POST',
        body: JSON.stringify({
            spaceAddress,
            tokenId: tokenIdHex,
        }),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${paymasterProxyAuthSecret}`,
        },
    });
    if (!response.ok) {
        throw new Error('Failed to encode subscription installation data', {
            cause: response.statusText,
        });
    }
    const json = (await response.json());
    if (!isHex(json.data.encodedInstallationData)) {
        throw new Error('Invalid encoded installation data');
    }
    return json.data.encodedInstallationData;
}
export async function uninstallSubscription(args) {
    const { paymasterProxyUrl, paymasterProxyAuthSecret, entityId, smartAccount, signer } = args;
    if (!isAddress(smartAccount.address)) {
        throw new Error('Invalid smart account address');
    }
    const response = await fetch(`${paymasterProxyUrl}/api/subscriptions/encode-uninstall`, {
        method: 'POST',
        body: JSON.stringify({
            entityId,
        }),
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${paymasterProxyAuthSecret}`,
        },
    });
    if (!response.ok) {
        throw new Error('Failed to encode subscription uninstall data', {
            cause: response.statusText,
        });
    }
    const json = (await response.json());
    if (!isHex(json.data.encodedUninstallData)) {
        throw new Error('Invalid encoded uninstall data');
    }
    const encodedUninstallData = json.data.encodedUninstallData;
    return smartAccount.sendUserOp({
        toAddress: [smartAccount.address],
        callData: [encodedUninstallData],
        functionHashForPaymasterProxy: 'uninstallSubscription',
        spaceId: undefined,
        signer,
        skipConfirmation: true,
    });
}
